import avatarModule from '../avatarModule';

/*
    Controls the scale section of the avatar page, which lets you modify width and height of your avatar
    Receives updates about scale changes through the avatarDetailsLoaded event
*/
function avatarScaleController(
  $scope,
  $log,
  $timeout,
  avatarService,
  avatarConstantService,
  avatarScaleService
) {
  'ngInject';

  $scope.scales = avatarScaleService.getScales();
  $scope.scaleProportionAndBodyTypeEnabled = false;

  $scope.updateScales = function() {
    $log.debug('updateScales');
    avatarScaleService.updateScales($scope.scales, $scope.scaleProportionAndBodyTypeEnabled);
    const sharedScales = avatarScaleService.getScales();
    const scales = {
      height: sharedScales.height.value / 100,
      width: sharedScales.width.value / 100,
      head: sharedScales.head.value / 100
    };
    if ($scope.scaleProportionAndBodyTypeEnabled) {
      scales.proportion = sharedScales.proportion.value / 100;
      scales.bodyType = sharedScales.bodyType.value / 100;
    }
    avatarService.setScales(scales).then(
      function(result) {
        $scope.refreshThumbnail();
      },
      function() {
        $scope.systemFeedback.error(avatarConstantService.scales.failedToUpdate);
      }
    );
  };

  $scope.initializeScaleMetrics = function(result) {
    const { avatarRules } = result;
    const { avatarDetails } = result;
    const { metaData } = result;
    $scope.scaleProportionAndBodyTypeEnabled =
      metaData.supportProportionAndBodyType && avatarRules.proportionsAndBodyTypeEnabledForUser;
    avatarScaleService.initializeScaleMetrics(
      avatarRules,
      metaData,
      $scope.scaleProportionAndBodyTypeEnabled
    );
    // needs a timeout to allow the max value to be applied to the input
    $timeout(function() {
      avatarScaleService.applyCurrentScale(avatarDetails, $scope.scaleProportionAndBodyTypeEnabled);
    });
  };

  $scope.$watch(
    function() {
      return $scope.avatarDataModel.isAvatarScaleEmbeddedInTab;
    },
    function(newValue, oldValue) {
      if (newValue && $scope.avatarLibrary) {
        $scope.initializeScaleMetrics($scope.avatarLibrary);
      }
    },
    true
  );

  $scope.$on(avatarConstantService.events.pageLoaded, function(event, result) {
    $scope.initializeScaleMetrics(result);
  });

  $scope.$on(avatarConstantService.events.avatarDetailsLoaded, function(event, result) {
    avatarScaleService.applyCurrentScale(result, $scope.scaleProportionAndBodyTypeEnabled);
  });
}

avatarModule.controller('avatarScaleController', avatarScaleController);

export default avatarScaleController;
